import { BillingAddress, BillingBusiness, BillingTotals } from "../../../index";

type UserSubscriptionDetailsProps = {
	id: string;
	nextTransaction: BillingTotals;
	recurringPrice: BillingTotals;
	address: BillingAddress;
	business?: BillingBusiness;
};

class UserSubscriptionDetails {
	constructor(public _: UserSubscriptionDetailsProps) {}

	static fromJson(data: any) {
		return new UserSubscriptionDetails({
			id: data.id,
			nextTransaction: BillingTotals.fromJson(data.next_transaction || {}),
			recurringPrice: BillingTotals.fromJson(
				data.recurring_transaction_details || {}
			),
			address: BillingAddress.fromJson(data.billing_address || {}),
			business:
				data.billing_business &&
				BillingBusiness.fromJson(data.billing_business || {}),
		});
	}

	toJson() {
		const res = {
			id: this._.id,
			next_transaction: this._.nextTransaction.toJson(),
			recurring_price: this._.recurringPrice.toJson(),
			billing_address: this._.address.toJson(),
			billing_business: this._.business?.toJson(),
		} as any;
		return res;
	}
}

export { UserSubscriptionDetails };
